module.exports = __webpack_public_path__ + "img/Klizer_Logo_JustName.8912ca9f.png";